import { z } from 'zod';

export * from './AddFromCatalog';

export const addFromCatalogSearchSchema = z.object({
  initIds: z.array(z.string()).default([]).catch([]),
  afcType: z
    .union([z.literal('znglist'), z.literal('category')])
    .nullable()
    .catch(null),
});

export type AddFromCatalogSearch = z.infer<typeof addFromCatalogSearchSchema>;
